import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitPaymentChangeSubmissionData } from './variable-benefit-payment-change-submission-data';

export class VariableBenefitPaymentChangeSubmission implements Deserializable {
  public previous!: VariableBenefitPaymentChangeSubmissionData | null;
  public new!: VariableBenefitPaymentChangeSubmissionData | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.previous) {
      this.previous = Deserialize.instanceOf(VariableBenefitPaymentChangeSubmissionData, this.previous);
    }

    if (this.new) {
      this.new = Deserialize.instanceOf(VariableBenefitPaymentChangeSubmissionData, this.new);
    }
  }
}
